import React, { useEffect, useRef, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  Box,
  FormControl,
  MenuItem,
  ThemeProvider,
  Typography,
  createTheme,
  Select,
} from "@mui/material";
import { Delete, Edit } from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link, useLocation } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { getApiCall, postApiCall, postFormApiCall } from "../../utils/api";
import tableIcons from "../component/MaterialIcon";
import EditStudents from "./modal/EditStudents";
import stateList from "../../data/states.json";

const ViewAllStudentBySchool = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const studentData = location.state?.studentData || [];
  const schoolsName = location.state?.schoolName || "School Name";

  useEffect(() => {
  }, []);

  const [data, setData] = useState([]);
  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    { title: "Phone", field: "phone" },
    {
      title: "Is Archived",
      field: "is_deleted",
      render: (rowData) => {
        return <>{rowData.is_deleted === true ? "Yes" : "No"}</>;
      },
    },
  ];

  // const [cityList, setCityList] = useState([]);
  // const [filterData, setFiterData] = useState({
  //   state: "",
  //   city: "",
  // });
  // const handleChange = async (event) => {
  //   setLoading(true);
  //   const { name, value } = event.target;
  //   const updatedFilterData = {
  //     ...filterData,
  //     [name]: value,
  //   };
  //   if (name === "state") {
  //     const selectedState = stateList.states.find(
  //       (state) => state.state_code === value
  //     );
  //     setCityList(selectedState ? selectedState.cities : []);
  //     updatedFilterData.city = "";
  //   }
  //   setFiterData(updatedFilterData);
  //   const res = await postApiCall(
  //     `admin/student/filterByStateAndCity`,
  //     updatedFilterData
  //   );
  //   setLoading(false);

  //   setData(res.data);
  //   res.data.forEach((data, index) => {
  //     data.serial = index + 1;
  //   });
  // };

  return (
    <div>
      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">{schoolsName}</h4>
              </div>
              {/* /.col */}
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Students</li>
                </ol>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </div>

        <section className="content mt-3">
          <div className="container-fluid">
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                icons={tableIcons}
                title="Students"
                columns={columns}
                data={studentData}
                onRowClick={(evt, selectedRow) =>
                  setSelectedRow(selectedRow.tableData.id)
                }
                options={{
                  exportButton: true,
                  actionsColumnIndex: -1,
                  headerStyle: {
                    backgroundColor: "rgb(0 123 255)",
                    color: "#FFF",
                    fontSize: 18,
                  },
                  rowStyle: (rowData, index) => ({
                    backgroundColor:
                      selectedRow === rowData.tableData.id
                        ? "#d3d4d1"
                        : index % 2 !== 0
                        ? "#EEE"
                        : "#FFF",
                  }),
                }}
                // components={{
                //   Toolbar: (props) => (
                //     <Box
                //       display="flex"
                //       justifyContent="space-between"
                //       alignItems="center"
                //       padding="10px"
                //     >
                //       {/* Left Side: Title */}
                //       <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                //         Students
                //       </Typography>
                //       <Box
                //         style={{
                //           display: "flex",
                //           justifyContent: "center",
                //           alignItems: "center",
                //         }}
                //       >
                //         <FormControl
                //           sx={{ width: "200px", marginRight: "16px" }}
                //         >
                //           <Select
                //             sx={{ height: "40px" }}
                //             name="state"
                //             value={filterData.state}
                //             onChange={handleChange}
                //             displayEmpty
                //           >
                //             <MenuItem value="" disabled>
                //               Select State
                //             </MenuItem>
                //             {stateList.states
                //               ?.sort((a, b) => a.name.localeCompare(b.name))
                //               ?.map((state) => (
                //                 <MenuItem
                //                   key={state.state_code}
                //                   value={state.state_code}
                //                 >
                //                   {state.name}
                //                 </MenuItem>
                //               ))}
                //           </Select>
                //         </FormControl>

                //         <FormControl
                //           sx={{ width: "200px", marginRight: "16px" }}
                //         >
                //           <Select
                //             sx={{ height: "40px" }}
                //             name="city"
                //             value={filterData.city}
                //             onChange={handleChange}
                //             displayEmpty
                //           >
                //             <MenuItem value="" disabled>
                //               Select State
                //             </MenuItem>
                //             {cityList.map((city) => (
                //               <MenuItem key={city} value={city}>
                //                 {city}
                //               </MenuItem>
                //             ))}
                //           </Select>
                //         </FormControl>
                //         <MTableToolbar {...props} />
                //       </Box>
                //     </Box>
                //   ),
                // }}
                // actions={[
                //   {
                //     icon: () => (
                //       <span style={{ color: "#5656ce" }}>
                //         <Edit />
                //       </span>
                //     ),
                //     tooltip: "Edit",
                //     onClick: (event, rowData) => handleEdit(rowData),
                //   },
                // ]}
              />
            </ThemeProvider>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ViewAllStudentBySchool;
